import {useEffect} from "react";
import "../fontAwesome"; // <-- registers icons globally
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

declare global {
  interface Window {
    hbspt: any;
  }
}

// async function getPhoneNumberFromCacheOrAPI(
//   setPhoneNumber: (phone: string) => void
// ) {
//   const cacheKey = "userPhoneNumber";
//   const cached = localStorage.getItem(cacheKey);

//   if (cached) {
//     setPhoneNumber(cached);
//     return;
//   }

//   const phoneNumbers: Record<string, string> = {
//     US: "+1 833-742-2672",
//     CA: "+1 833-742-2672",
//     GB: "+44 23 9408 0126",
//     AU: "+61 1800 936 108",
//     NZ: "+64 800 033 171",
//     SG: "+65 6335 3541",
//     PH: "+65 6335 3541",
//     TW: "+65 6335 3541",
//     MY: "+65 6335 3541",
//     VM: "+65 6335 3541",
//     CH: "+65 6335 3541",
//   };

//   try {
//     const response = await fetch("https://freeipapi.com/api/json");
//     const data = await response.json();
//     const userCountryCode = data?.countryCode || "US";
//     const phone = phoneNumbers[userCountryCode] || phoneNumbers.US;

//     setPhoneNumber(phone);
//   } catch (error) {
//     console.error("Error fetching IP geolocation:", error);
//     setPhoneNumber(phoneNumbers.US);
//   }
// }

const PartnerBadges = () => {
  const badges = [
    "amazon-connect-partner-badge",
    "select-tier-services-badge",
    "board-of-investments-badge",
    "aap-badge",
    "aws-marketplace-badge",
  ];
  return (
    <div className="partner-badges flex-box-blk">
      {badges.map((badge, index) => (
        <figure key={index}>
          <img
            src={`https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/images/${badge}.png`}
            alt={badge.replace(/-/g, " ")}
          />
        </figure>
      ))}
    </div>
  );
};

const FooterLinks = () => (
  <>
    <div>
      <h3>COMPANY</h3>
      <ul>
        <li>
          <a
            href="https://www.icxeed.ai/about"
            target="_blank"
            rel="noopener noreferrer">
            About
          </a>
        </li>
        <li>
          <a
            href="https://www.icxeed.ai/become-a-partner"
            target="_blank"
            rel="noopener noreferrer">
            Become a Partner
          </a>
        </li>
        <li>
          <a
            href="https://www.icxeed.ai/library"
            target="_blank"
            rel="noopener noreferrer">
            Library
          </a>
        </li>
        <li>
          <a
            href="https://icxeed.careers/"
            target="_blank"
            rel="noopener noreferrer">
            Careers
          </a>
        </li>
      </ul>
    </div>

    <div>
      <h3>teCXnology</h3>
      <ul>
        {[
          ["Amazon Connect Launch", "amazon-connect-launch"],
          ["Amazon Connect Accelerated", "amazon-connect-accelerated"],
          ["Digital AI Concierge", "digital-ai-concierge"],
          ["Intelligent IVR Design", "intelligent-ivr-design"],
          ["Smart Cart AI", "smart-cart-ai"],
          ["CX Perspectives", "cx-perspectives"],
        ].map(([label, slug], i) => (
          <li key={i}>
            <a
              href={`https://www.icxeed.ai/${slug}`}
              target="_blank"
              rel="noopener noreferrer">
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>

    <div>
      <h3>COGNITIVE EXPERTS</h3>
      <ul>
        {[
          [
            "Software, Cloud, & Data Engineers",
            "software-cloud-data-engineers",
          ],
          ["eLearning Design & Development", "elearning-design-development"],
          [
            "Social Media Content & Engagement",
            "social-media-content-engagement",
          ],
          ["Proactive Website Chat", "proactive-website-chat"],
          [
            "Contact & Call Centre Optimisation",
            "contact-call-centre-optimisation",
          ],
          ["Talent as a Service (TaaS)", "talent-as-a-service"],
        ].map(([label, slug], i) => (
          <li key={i}>
            <a
              href={`https://www.icxeed.ai/${slug}`}
              target="_blank"
              rel="noopener noreferrer">
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  </>
);

const FooterContact = ({phoneNumber}: {phoneNumber: string}) => (
  <div>
    <h3>CONTACT</h3>
    <div className="contact-section-blk-footer">
      <FontAwesomeIcon icon="phone" />
      <p id="contact-number-blk">+65 6335 3541</p>
    </div>

    <h3>STAY IN THE LOOP</h3>
    <section id="stay-in-the-loop-blk"></section>

    <h3>SOCIALS</h3>
    <ul className="social-links">
      <li>
        <a
          href="https://www.instagram.com/icxeedlife/"
          target="_blank"
          rel="noopener noreferrer">
          <FontAwesomeIcon icon={["fab", "instagram"]} />
        </a>
      </li>
      <li>
        <a
          href="https://x.com/iCXeed"
          target="_blank"
          rel="noopener noreferrer">
          <FontAwesomeIcon icon={["fab", "x-twitter"]} />
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/company/icxeed"
          target="_blank"
          rel="noopener noreferrer">
          <FontAwesomeIcon icon={["fab", "linkedin-in"]} />
        </a>
      </li>
      <li>
        <a
          href="https://web.facebook.com/iCXeed/"
          target="_blank"
          rel="noopener noreferrer">
          <FontAwesomeIcon icon={["fab", "facebook-f"]} />
        </a>
      </li>
    </ul>
  </div>
);

const FooterInfo = () => (
  <section className="footer-info">
    <p>
      Copyright © <span className="copyright-year">2025</span> iCXeed. All
      Rights Reserved.
    </p>
    <nav aria-label="Footer Navigation">
      <ul>
        <li>
          <a
            href="https://www.icxeed.ai/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer">
            Privacy Policy
          </a>
        </li>
        <li>
          <a
            href="https://www.icxeed.ai/cookie-policy/"
            target="_blank"
            rel="noopener noreferrer">
            Cookie Policy
          </a>
        </li>
        <li>
          <a
            href="https://www.icxeed.ai/terms-and-conditions/"
            target="_blank"
            rel="noopener noreferrer">
            Terms and Conditions
          </a>
        </li>
      </ul>
    </nav>
  </section>
);

const FooterPage = () => {
  useEffect(() => {
    const formConfigs = [
      {
        formId: "5ca6de7f-4566-4b3a-b9f5-e6edb74274e3",
        target: "#stay-in-the-loop-blk",
      },
    ];

    const loadForms = () => {
      formConfigs.forEach(({formId, target}) => {
        const element = document.querySelector(target);
        if (!element) return;

        if (window.hbspt?.forms?.create) {
          window.hbspt.forms.create({
            region: "na1",
            portalId: "22693629",
            formId,
            target,
          });
        } else {
          setTimeout(loadForms, 500);
        }
      });
    };

    if (!document.getElementById("hubspot-script")) {
      const script = document.createElement("script");
      script.id = "hubspot-script";
      script.src = "https://js.hsforms.net/forms/v2.js";
      script.async = true;
      script.onload = loadForms;
      document.body.appendChild(script);
    } else {
      loadForms();
    }
  }, []);

  return (
    <footer>
      {/* Logo + Badges */}
      <div className="header-logo-section">
        <div className="main-container-blk">
          <section className="flex-box-blk logo-section-footer">
            <figure>
              <img
                src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/images/icxeed-logo-white.png"
                alt="iCXeed Logo"
              />
            </figure>
            <PartnerBadges />
          </section>
        </div>
      </div>

      <div className="divider-blk"></div>

      {/* Footer Links + Contact */}
      <div className="main-container-blk">
        <div className="link-section-footer-blk">
          <FooterLinks />
          <FooterContact phoneNumber={""} />
        </div>
      </div>

      <div className="divider-blk"></div>

      {/* Footer Info */}
      <div className="main-container-blk">
        <FooterInfo />
      </div>
    </footer>
  );
};

export default FooterPage;
